import { GROWTH_MILESTONES, GROWTH_STATS } from "@/data/indiaContent";

const toneText = { saffron: "text-[var(--saffron-deep)]", green: "text-[var(--india-green)]", chakra: "text-[var(--chakra)]" };

export function GrowthSection() {
  return (
    <section id="growth" className="relative z-10 scroll-mt-24 py-20" data-testid="growth-section">
      <div className="absolute inset-0 -z-10 bg-[var(--green-tint)]/70" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="eyebrow text-[var(--india-green)]">विकास की राह</p>
          <h2 className="mt-3 font-serif text-3xl font-bold tracking-tight text-[var(--chakra-deep)] sm:text-4xl">The Growth Path</h2>
          <p className="mt-4 text-base text-stone-600 md:text-lg">
            From a nation that imported grain to one that lands on the Moon. The story is still being written.
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {GROWTH_STATS.map((s, i) => (
            <div key={s.label} data-testid={`growth-stat-${i}`} className="rounded-2xl border border-[var(--line)] bg-white p-6">
              <p className={`font-serif text-3xl font-bold sm:text-4xl ${toneText[s.tone]}`}>{s.value}</p>
              <p className="mt-2 text-sm text-stone-600">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="relative mt-16">
          <div className="absolute left-4 top-0 h-full w-0.5 bg-gradient-to-b from-[var(--saffron)] via-stone-200 to-[var(--india-green)] md:left-1/2" />
          <ol className="space-y-10">
            {GROWTH_MILESTONES.map((m, i) => (
              <li key={m.year} data-testid={`growth-milestone-${i}`} className={`relative flex md:w-1/2 ${i % 2 === 0 ? "md:pr-12" : "md:ml-auto md:pl-12"} pl-12 md:pl-0`}>
                <span className={`absolute top-1 h-4 w-4 rounded-full border-4 border-white shadow ring-1 ring-stone-200 ${i % 2 === 0 ? "bg-[var(--saffron)]" : "bg-[var(--india-green)]"} left-2.5 md:left-auto ${i % 2 === 0 ? "md:-right-2" : "md:-left-2"}`} />
                <div className={`card-lift w-full rounded-2xl border border-[var(--line)] bg-white p-5 ${i % 2 === 0 ? "md:text-right" : ""} ${i % 2 !== 0 ? "md:pl-5" : ""}`}>
                  <p className="font-serif text-2xl font-bold text-[var(--chakra)]">{m.year}</p>
                  <h3 className="mt-1 font-semibold text-stone-900">{m.title}</h3>
                  <p className="mt-1 text-sm text-stone-600">{m.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
